import { createContext, useContext, useLayoutEffect } from 'react';
import { isNativePlatform } from '../services/native/platformService.js';
import { hideSplashWhenReady } from '../services/native/splashScreenService.js';

// Authenticated layouts hold readiness until their initial navigation and
// course data settle. Standalone pages (sign-in, player, etc.) can reveal as
// soon as they render, without waiting for requests those layouts never start.
export const NativeStartupReadyContext = createContext(true);

export function NativeSplashReady({ children, ready }) {
  const shellReady = useContext(NativeStartupReadyContext);
  const canReveal = ready ?? shellReady;

  useLayoutEffect(() => {
    if (!isNativePlatform() || !canReveal) return;

    // Let the committed route and tab bar paint before removing the native
    // overlay. Layout-effect cleanup also cancels this if Suspense hides the
    // route, a redirect replaces it, or readiness changes before the next paint.
    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        void hideSplashWhenReady();
      });
    });
    return () => cancelAnimationFrame(frame);
  }, [canReveal]);

  return children;
}
